import React, { Fragment, useState, useRef, useEffect } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { RecordRTCPromisesHandler, MediaStreamRecorder } from 'recordrtc';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import Countdown from '../Countdown';

import '../modals.css';

const TFVideoRecorder = ( { close, vidType, setBlob } ) => {
    const [ showCountdown, setShowCountdown ] = useState( false );
    const closeCountdown = () => setShowCountdown( false );
    const refVideo = useRef(null);
    const recorderRef = useRef(null);
    
    useEffect( () => {
        let stream;

        const getStream = async ( t ) => {
            // let stream;

            if ( t === 'face' ) {
                stream = await navigator.mediaDevices.getUserMedia( { video: true, audio: true } );
                
            } else if ( t === 'screen' ) {
                stream = await navigator.mediaDevices.getDisplayMedia( { video: true, audio: true } );
            }

            return stream;
        };

        getStream( vidType ).then( ( s ) => {
            refVideo.current.srcObject = s;
            refVideo.current.muted = true;
            refVideo.current.volume = 0;

            recorderRef.current = new RecordRTCPromisesHandler( s, { 'type': 'video', 'mimeType': 'video/webm\;codecs=h264', 'recorderType': MediaStreamRecorder, 'frameRate': 60 } );
        } );

        return () => {
            if ( stream ) {
                stream.stop();
            }
        };
    }, [ vidType ] );

    const handleRecording = async () => {
        // setShowCountdown( true );
        
        // let stream;

        // if ( vidType === 'face' ) {
        //     stream = await navigator.mediaDevices.getUserMedia( { video: true, audio: true } );
            
        // } else if ( vidType === 'screen' ) {
        //     stream = await navigator.mediaDevices.getDisplayMedia( { video: true, audio: true } );
        // }

        // refVideo.current.srcObject = stream;
        // refVideo.current.muted = true;
        // refVideo.current.volume = 0;

        // recorderRef.current = new RecordRTCPromisesHandler( stream, { 'type': 'video', 'mimeType': 'video/webm\;codecs=h264', 'recorderType': MediaStreamRecorder, 'frameRate': 60 } );
        console.log( 'awaiting start recording: ' + new Date().toISOString() );
        await recorderRef.current.startRecording();
        console.log( 'start recording: ' + new Date().toISOString() );
        // recorderRef.current.stream = stream;
        recorderRef.current.stream = refVideo.current.srcObject;
    };
    
    const handleStop = async () => {
        await recorderRef.current.stopRecording();
        
        refVideo.current.srcObject.stop();
        refVideo.current.srcObject = null;

        const b = await recorderRef.current.getBlob();
        refVideo.current.src = URL.createObjectURL( b );
        setBlob( b );
        console.log( 'vid src: ' + refVideo.current.src );
        recorderRef.current.stream.getTracks( t => t.stop() );
        await recorderRef.current.reset();
        await recorderRef.current.destroy();

        close();
    };
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '660px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 1 } }>
                <Row className='py-3 align-items-center'>
                    <Col className='py-0 px-1'>
                        <video autoPlay playsInline ref={refVideo} style={ { width: '640px', height: '480px' } }></video>
                    </Col>
                </Row>
                <Row className='pt-2'>
                    <Col>
                        <Button variant='link' style={ { color: 'red' } } onClick={ handleRecording }><RadioButtonCheckedIcon /></Button>
                        <Button variant='link' onClick={ handleStop }><StopCircleIcon /></Button>
                    </Col>
                </Row>
            </Box>
            {/* <Modal open={showCountdown} onClose={ closeCountdown }>
                <Countdown num={3} close={closeCountdown} />
            </Modal> */}
        </Fragment>
    )
}
  
export default TFVideoRecorder;